var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.868,
    height: 21.081,
    viewBox: "0 0 20.868 21.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9562",
    "data-name": "Group 9562",
    transform: "translate(437.18 22767)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    cx: 6.25,
    cy: 6.25,
    r: 6.25,
    transform: "translate(-435.18 -22765)",
    fill: "none",
    stroke: "#1d1d26",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3689",
    "data-name": "Line 3689",
    x1: 5.36,
    y1: 5.36,
    transform: "translate(-424.5 -22754.107)",
    fill: "none",
    stroke: "#1d1d26",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.db6e8f3921fa27fb2e2b4ed8f1b4c7f5.svg";
export { ForwardRef as ReactComponent };